import { useNavigate } from "react-router-dom";

const PD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif";

const platformLinks = [
  { label: "기능 소개",  action: "scroll", target: "#features" },
  { label: "기업 유형",  action: "scroll", target: "#company-types" },
  { label: "교육 방식",  action: "scroll", target: "#how-it-works" },
  { label: "강사 도구",  action: "nav",    target: "/login" },
];
const supportLinks = [
  { label: "도입 문의",       action: "scroll", target: "#contact" },
  { label: "자주 묻는 질문", action: "nav",    target: "/faq" },
  { label: "이용 가이드",    action: "nav",    target: "/guide" },
  { label: "기술 지원",      action: "scroll", target: "#contact" },
];
const companyLinks = [
  { label: "회사 소개",  action: "scroll", target: "#features" },
  { label: "운영정책",   action: "nav",    target: "/policy" },
  { label: "채용 안내",  action: "nav",    target: "/careers" },
];
const legalLinks = [
  { label: "개인정보처리방침", path: "/privacy" },
  { label: "이용약관",         path: "/terms" },
  { label: "운영정책",         path: "/policy" },
];

export default function FooterSection() {
  const navigate = useNavigate();

  const handleLink = (action: string, target: string) => {
    if (action === "nav") {
      navigate(target);
    } else {
      const el = document.querySelector(target);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/");
        setTimeout(() => document.querySelector(target)?.scrollIntoView({ behavior: "smooth" }), 300);
      }
    }
  };

  return (
    <footer className="bg-[#F5F5F5] border-t border-black/[0.08]" style={{ fontFamily: PD }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8 md:gap-10 mb-10 md:mb-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-3 md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4 cursor-pointer" onClick={() => navigate("/")}>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#4B6CF7] shrink-0">
                <span style={{ color: '#FFFFFF' }} className="font-bold text-sm">K</span>
              </div>
              <span style={{ color: '#111111' }} className="font-semibold text-base">K-ArtPEN</span>
            </div>
            <p className="text-[#888888] text-xs leading-relaxed max-w-xs mb-3">
              문화예술 기업 경영을 직접 경험하는 시뮬레이션 교육 플랫폼. 음악 레이블부터 광고에이전시까지, 실전 같은 경영 교육을 제공합니다.
            </p>
            <p className="text-[#AAAAAA] text-xs">운영: <span className="text-[#888888]">주식회사 툴뮤직</span></p>
          </div>

          {/* 플랫폼 */}
          <div>
            <p className="text-[#444444] text-[10px] font-semibold uppercase tracking-widest mb-4">플랫폼</p>
            <ul className="space-y-2.5">
              {platformLinks.map((link) => (
                <li key={link.label}>
                  <button
                    type="button"
                    onClick={() => handleLink(link.action, link.target)}
                    className="text-[#888888] hover:text-[#333333] text-xs transition-colors cursor-pointer whitespace-nowrap text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 지원 */}
          <div>
            <p className="text-[#444444] text-[10px] font-semibold uppercase tracking-widest mb-4">지원</p>
            <ul className="space-y-2.5">
              {supportLinks.map((link) => (
                <li key={link.label}>
                  <button
                    type="button"
                    onClick={() => handleLink(link.action, link.target)}
                    className="text-[#888888] hover:text-[#333333] text-xs transition-colors cursor-pointer whitespace-nowrap text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 회사 */}
          <div>
            <p className="text-[#444444] text-[10px] font-semibold uppercase tracking-widest mb-4">회사</p>
            <ul className="space-y-2.5">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <button
                    type="button"
                    onClick={() => handleLink(link.action, link.target)}
                    className="text-[#888888] hover:text-[#333333] text-xs transition-colors cursor-pointer whitespace-nowrap text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-black/[0.07] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-center sm:text-left">
            <p className="text-[#AAAAAA] text-xs">© 2026 주식회사 툴뮤직. All rights reserved.</p>
            <p className="text-[#BBBBBB] text-[10px] mt-0.5">K-ArtPEN은 주식회사 툴뮤직이 운영하는 문화예술 경영 교육 플랫폼입니다.</p>
          </div>
          <div className="flex items-center gap-3 sm:gap-5 flex-wrap justify-center sm:justify-end">
            {legalLinks.map((t) => (
              <button
                key={t.label}
                type="button"
                onClick={() => navigate(t.path)}
                className="text-[#AAAAAA] hover:text-[#555555] text-xs cursor-pointer transition-colors whitespace-nowrap"
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
